// src/core/schema/schemaFormat.ts

export type TypeClass = {
    num: boolean;
    dt: boolean;
    bool: boolean;
  };
  
  /**
   * Classify a SQL type string into numeric/date/time/boolean flags.
   */
  export const classifyType = (t: string): TypeClass => ({
    num: /int|float|double|decimal|numeric|number/i.test(t),
    dt: /date|time|timestamp/i.test(t),
    bool: /bool/i.test(t),
  });
  
  /**
   * Format a value for display based on its classified type.
   */
  export const fmtValue = (v: any, cls: TypeClass): string => {
    if (v === null || v === "NULL") return "NULL";
    if (cls.num) {
      const num = Number(v);
      return Number.isFinite(num)
        ? Number.isInteger(num)
          ? num.toLocaleString()
          : num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : String(v);
    }
    if (cls.bool) return String(v) === "true" ? "True" : "False";
    if (cls.dt) return String(v);
    if (typeof v === "string")
      return v.length > 30 ? v.slice(0, 27) + "…" : v;
    if (typeof v === "object") {
      const s = JSON.stringify(v);
      return s.length > 30 ? s.slice(0, 27) + "…" : s;
    }
    return String(v);
  };
  
  /**
   * Return CSS classes based on value type for styling.
   */
  export const valueClass = (v: any, cls: TypeClass): string => {
    if (v === null || v === "NULL") return "text-muted-foreground italic";
    if (cls.num) return "font-mono text-right";
    if (cls.bool) return "font-semibold";
    if (cls.dt) return "font-mono text-xs";
    return "font-mono text-xs";
  };